import { z } from "zod";

import { DateIsoString } from "@/core/types";
import { PhoneNumber } from "@/data/phones";

export const JobApplicationComment = z
  .object({
    authorFirstName: z.string().nullable(),
    authorLastName: z.string().nullable(),
    commentCreatedDate: DateIsoString.nullable(),
    authorEmail: z.string().nullish(),
    authorPhone: PhoneNumber.nullish(),
    externalComment: z.string().nullable(),
  })
  .passthrough();

export type JobApplicationComment = z.infer<typeof JobApplicationComment>;
